import api from './api';
import { User } from '../types';

export const userApi = {
  // Get all users (public)
  getAllUsers: async (limit?: number) => {
    const response = await api.get('/api/user/all', {
      params: { limit }
    });
    return response.data;
  },

  // Get current user profile
  getProfile: async () => {
    const response = await api.get('/api/user/profile');
    return response.data;
  },

  // Update profile
  updateProfile: async (data: FormData) => {
    const response = await api.put('/api/user/profile', data, {
      headers: { 
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Test Pinata connection
  testPinataConnection: async () => {
    const response = await api.get('/api/user/test-pinata');
    return response.data;
  }
};